var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSdIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.668 26.9417H33.1263",
    stroke: "#F9536E",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.668 35.7749H27.3405",
    stroke: "#F9536E",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0846 13.2501H30.918C35.3346 13.2501 35.3346 11.0417 35.3346 8.83341C35.3346 4.41675 33.1263 4.41675 30.918 4.41675H22.0846C19.8763 4.41675 17.668 4.41675 17.668 8.83341C17.668 13.2501 19.8763 13.2501 22.0846 13.2501Z",
    stroke: "#F9536E",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3333 8.87744C42.6871 9.27494 46.375 11.9912 46.375 22.0833V35.3333C46.375 44.1666 44.1667 48.5833 33.125 48.5833H19.875C8.83333 48.5833 6.625 44.1666 6.625 35.3333V22.0833C6.625 12.0133 10.3129 9.27494 17.6667 8.87744",
    stroke: "#F9536E",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdIcon04);
export default __webpack_public_path__ + "static/media/sd-icon04.be12fc70ff5b956f046c9a65858a0903.svg";
export { ForwardRef as ReactComponent };